import React from 'react';
import { Layout } from 'antd';
import { ReactComponent as EuropeanUnionLogo } from 'assets/icons/european_union.svg';
import { ReactComponent as GreeceGovernmentLogo } from 'assets/icons/government-greece-logo2.svg';
import { ReactComponent as GreenMinistryLogo } from 'assets/icons/green_ministry_gov.svg';
import { ReactComponent as Tayped } from 'assets/icons/tayped_logo.svg';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const { Content } = Layout;

const Footer = () => {
  const loadingLocales = useSelector(state=> state.forms.loadingLocales);
  const loadingTaxis = useSelector(state=> state.user.loading);
  return (
    !loadingLocales && !loadingTaxis &&
    <div className="footer-container">
    <div className="footer-background"></div>
    <div className="footer-content">
      <div className="footer-logo">
        <GreenMinistryLogo />
      </div>
      <div className="footer-logo">
        <EuropeanUnionLogo />
      </div>
      <div className="footer-logo">
        <GreeceGovernmentLogo />
      </div>
      {/* <div className="footer-logo">
          <Tayped/>
      </div>  */}
    </div>
  </div>
  );
};

export default Footer;
